import React, { useState, useEffect, useRef } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import "./AutocompleteTextbox.scss";
import { getCustomers } from "../../api/customer/getCustomers";
import { ICustomer } from "../../api/customer/ICustomer";

interface AutocompleteTextboxProps {
  onCustomerNameSelect: (customerName: string, customerId: string) => void;
  defaultValue?: string;
}

const AutocompleteTextbox: React.FC<AutocompleteTextboxProps> = ({
  onCustomerNameSelect,
  defaultValue,
}) => {
  const [inputValue, setInputValue] = useState(defaultValue || "");
  const [options, setOptions] = useState<ICustomer[]>([]);
  const autoCompleteRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (inputValue.length >= 3) {
        try {
          const customers = await getCustomers(inputValue);
          setOptions(customers);
        } catch (error) {
          console.error("Failed to fetch customers", error);
          setOptions([]);
        }
      } else {
        setOptions([]);
      }
    };

    fetchData();
  }, [inputValue]);

  const handleSelect = (
    _: React.SyntheticEvent<Element, Event>,
    value: ICustomer | string | null,
  ) => {
    if (value && typeof value === "object") {
      onCustomerNameSelect(value.name, value.id.toString());
    }
  };


  return (
    <Autocomplete
    autoHighlight={true}
      ref={autoCompleteRef}
      className="AutoCompleteContainer"
      freeSolo
      options={options}
      getOptionLabel={(option) => {
        return (option as ICustomer).name}}
              defaultValue={{ name: defaultValue ?? "", id: 0 }}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onChange={handleSelect}
      renderInput={(params) => (
        <div ref={params.InputProps.ref}>
          <input
            type="text"
            {...params.inputProps}
          />
        </div>
      )}
    />
  );
};

export default AutocompleteTextbox;
